/*!
  * @almamedia/module-logger
  *
  */
var S=Object.defineProperty,y=Object.defineProperties;var A=Object.getOwnPropertyDescriptors;var p=Object.getOwnPropertySymbols;var T=Object.prototype.hasOwnProperty,x=Object.prototype.propertyIsEnumerable;var h=(t,e,o)=>e in t?S(t,e,{enumerable:!0,configurable:!0,writable:!0,value:o}):t[e]=o,g=(t,e)=>{for(var o in e||(e={}))T.call(e,o)&&h(t,o,e[o]);if(p)for(var o of p(e))x.call(e,o)&&h(t,o,e[o]);return t},d=(t,e)=>y(t,A(e));var l;(function(n){n.ALMA_BRAND="MediumOrchid",n.MODULE_VERSION="SlateGray",n.MESSAGE_CONTEXT="DarkSlateGray",n.BLACK="Black",n.WHITE="White";})(l||(l={}));var i;(function(r){r.GEO_CLIENT="GeoClient",r.CMP_CLIENT="ConsentClient",r.ACCOUNT_ANALYTICS="AccountAnalytics",r.ACCOUNT_CORE="AccountCore",r.TUNNUS_PRELOGIN="TunnusPrelogin",r.SAMMIO_SENDER="SammioSender",r.RESERVATION_1="Reservation1",r.RESERVATION_2="Reservation2",r.RESERVATION_3="Reservation3",r.RESERVATION_4="Reservation4";})(i||(i={}));var c={[i.GEO_CLIENT]:"MediumSpringGreen",[i.CMP_CLIENT]:"MistyRose",[i.ACCOUNT_ANALYTICS]:"DodgerBlue",[i.ACCOUNT_CORE]:"DeepSkyBlue",[i.TUNNUS_PRELOGIN]:"CornflowerBlue",[i.SAMMIO_SENDER]:"Yellow",[i.RESERVATION_1]:"HotPink",[i.RESERVATION_2]:"DeepPink",[i.RESERVATION_3]:"DarkKhaki",[i.RESERVATION_4]:"Aqua"};var L={"font-weight":"900",padding:"2px 0.5em 2px 0.5em",color:l.BLACK};function C(t){let e=c[t];return {companyName:d(g({},L),{color:l.WHITE,"background-color":l.ALMA_BRAND}),AlmaModuleName:d(g({},L),{color:l.BLACK,"background-color":e}),moduleVersion:d(g({},L),{color:l.WHITE,"background-color":l.MODULE_VERSION}),messageContext:d(g({},L),{color:l.WHITE,"background-color":l.MESSAGE_CONTEXT})}}var E=t=>Object.keys(t).map(e=>`${e}: ${t[e]};`).join(" ");function m(t){if(t.enableLogPrefix!==!0)return t.args;let e=C(t.AlmaModuleName),o=`%c${t.companyName}%c${t.AlmaModuleName}`,s=[E(e.companyName),E(e.AlmaModuleName)];return typeof t.moduleVersion=="string"&&(o=`${o}%c${t.moduleVersion}`,s.push(E(e.moduleVersion))),typeof t.messageContext=="string"&&(o=`${o}%c${t.messageContext}`,s.push(E(e.messageContext))),[o,...s,...t.args]}var a=class{constructor(e,o){this.companyName="ALMA",this.AlmaModuleName=e,this.moduleColor=c[e],(o==null?void 0:o.moduleVersion)&&this.validateModuleVersion(o.moduleVersion)&&(this.moduleVersion=o.moduleVersion),this.registerGlobalToggles();}validateModuleVersion(e){if(typeof e=="undefined")return !1;if(/dev|development/gi.test(e)||/^v\d+$/.test(e)===!0||/^v\d+\.\d+\.\d+.*/.test(e)===!0)return !0;throw new Error(`Invalid moduleVersion given: ${e}`)}registerGlobalToggles(){window.ALMA=window.ALMA||{},window.ALMA.moduleLoggerV1=window.ALMA.moduleLoggerV1||{toggle:this.toggleLogs,prefixes:this.toggleLogPrefixes};}areLogsEnabled(){try{return window.localStorage.getItem(a.LOGS_TOGGLE_KEY)==="true"}catch(e){return !1}}toggleLogs(){try{let e=window.localStorage.getItem(a.LOGS_TOGGLE_KEY)!=="true";return window.localStorage.setItem(a.LOGS_TOGGLE_KEY,String(e)),e}catch(e){return console.error("Could not toggle logs",e),!1}}areLogPrefixDisabled(){try{return window.localStorage.getItem(a.LOGS_PREFIX_TOGGLE_KEY)==="true"}catch(e){return !1}}toggleLogPrefixes(){try{let e=window.localStorage.getItem(a.LOGS_PREFIX_TOGGLE_KEY)!=="true";return window.localStorage.setItem(a.LOGS_PREFIX_TOGGLE_KEY,String(e)),e}catch(e){return console.error("Could not toggle log prefix setting",e),!0}}logger(e,o,...s){if(window.console&&(this.areLogsEnabled()||e==="critical")){let f=m({enableLogPrefix:!this.areLogPrefixDisabled(),companyName:this.companyName,AlmaModuleName:this.AlmaModuleName,moduleVersion:this.moduleVersion,messageContext:o,args:s}),n=e==="critical"?"error":e;window.console[n](...f);}}debug(...e){this.logger("debug",void 0,...e);}info(...e){this.logger("info",void 0,...e);}trace(...e){this.logger("trace",void 0,...e);}warn(...e){this.logger("warn",void 0,...e);}error(...e){this.logger("error",void 0,...e);}critical(...e){this.logger("critical",void 0,...e);}debugWithContext(e,...o){this.logger("debug",e,...o);}infoWithContext(e,...o){this.logger("info",e,...o);}traceWithContext(e,...o){this.logger("trace",e,...o);}warnWithContext(e,...o){this.logger("warn",e,...o);}errorWithContext(e,...o){this.logger("error",e,...o);}criticalWithContext(e,...o){this.logger("critical",e,...o);}},u=a;u.LOCALSTORAGE_PREFIX="ALMA_CROSS_SITE_LOGGER",u.LOGS_TOGGLE_KEY=`${a.LOCALSTORAGE_PREFIX}_ENABLED`,u.LOGS_PREFIX_TOGGLE_KEY=`${a.LOCALSTORAGE_PREFIX}_PREFIXED`;

class AnalyticsEvents {
  logger;
  ga4EventQueue = [];
  cmpAvailable;
  constructor({ logger }) {
    this.logger = logger;
    this.cmpAvailable = false;
  }
  // Push event data to dataLayer. With GA4 GTM tags will take care of the rest
  // (including checking for required consents).
  dispatchGA4Event = (event) => {
    const data = {
      event: "sendAlmaAccountGAEvent",
      event_name: "alma_account",
      alma_account_event_action: event.action ?? "",
      alma_account_login_type: event.type ?? "",
      alma_account_event_status: event.status ?? "",
      alma_account_client_id: event.clientId ?? "",
      alma_account_event_source: event.source ?? "",
      alma_account_user_hash: event.almaIDHash ?? "",
      alma_account_lang: event.lang ?? "",
      alma_account_mode: event.mode ?? "",
      alma_account_theme: event.theme ?? ""
    };
    this.logger.info("Push GA4 event to dataLayer", data);
    window.dataLayer.push(data);
  };
  setCMPAvailable = () => {
    this.cmpAvailable = true;
  };
  emptyGA4EventQueue = async () => {
    this.logger.info("Emptying GA4 event queque", [...this.ga4EventQueue]);
    for (const event of this.ga4EventQueue) {
      await this.sendEvent(event);
    }
    this.ga4EventQueue = [];
  };
  sendEvent = (ga4Event) => {
    return new Promise((resolve, reject) => {
      if (this.cmpAvailable) {
        try {
          this.dispatchGA4Event(ga4Event);
          resolve();
        } catch (error) {
          reject(error);
        }
      } else {
        try {
          this.logger.info("Adding GA4 event to queue", ga4Event);
          this.ga4EventQueue.push(ga4Event);
          resolve();
        } catch (error) {
          reject(error);
        }
      }
    });
  };
}

const getEventSourceFromSessionStorage = () => {
  const source = sessionStorage.getItem("evtSrc");
  if (source) {
    sessionStorage.removeItem("evtSrc");
  }
  return source ?? "";
};
const canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement === "function";
const continueOnceCMPAvailable = (callback) => {
  const events = [
    "alma_cmp_v2_consents_available_repetitive",
    "alma_b2b_consent_available_repetitive"
  ];
  const onCMPAvailable = () => {
    for (const event of events) {
      window.removeEventListener(event, onCMPAvailable, false);
    }
    callback();
  };
  for (const event of events) {
    window.addEventListener(event, onCMPAvailable, false);
  }
};

class AlmaAccountAnalytics {
  logger;
  static instance;
  clientId;
  timeout;
  cmpAvailable;
  eventHandler;
  sendEvent;
  setCMPAvailable;
  emptyGA4EventQueue;
  /**
   * @method resetInstance
   * @description
   * Reset the Analytics instance
   * @example <script type="module">
      const { AlmaAccountAnalytics } = await import('@almamedia/alma-account-analytics');
      AlmaAccountAnalytics.resetInstance()
   <\/script>
   */
  static resetInstance() {
    AlmaAccountAnalytics.instance = void 0;
  }
  /**
   * @method getInstance
   * @description
   * Create a new Analytics instance
   * @param {Object} options - The options for creating the Analytics instance
   * @param {string} options.clientId - The client ID for the auth0 application
   * @param {number} [options.timeout] - Adjust the wait time for pushing first events to dataLayer.
   *    By default we wait for CMP consents to be available + extra 1000ms to be sure that everything
   *    is ready in GTM. If you need to adjust the extra wait from the default 1000ms, pass a timeout
   *    value here in milliseconds. Don't use this option unless it's really needed.
   * @returns {AlmaAccountAnalytics} - A new Analytics instance
   * @example <script type="module">
      const { AlmaAccountAnalytics } = await import('@almamedia/alma-account-analytics');
      window.AlmaAccountAnalytics = await AlmaAccountAnalytics.getInstance({
        clientId: "fG1vtWu4UYtOGRANZKZpqugWvhrjMPsQ", // 🚨 EXAMPLE CLIENT ID, REPLACE WITH YOUR OWN 🚨
      })
   <\/script>
   */
  static getInstance({ clientId, timeout }) {
    if (!AlmaAccountAnalytics.instance) {
      AlmaAccountAnalytics.instance = new AlmaAccountAnalytics();
      AlmaAccountAnalytics.instance.cmpAvailable = false;
      AlmaAccountAnalytics.instance.clientId = clientId;
      AlmaAccountAnalytics.instance.timeout = typeof timeout === "number" ? timeout : 1e3;
      if (canUseDOM) {
        AlmaAccountAnalytics.instance.logger = new u(
          i.ACCOUNT_ANALYTICS
        );
        AlmaAccountAnalytics.instance.logger.info("Starting initalization");
        AlmaAccountAnalytics.instance.eventHandler = new AnalyticsEvents({
          logger: AlmaAccountAnalytics.instance.logger
        });
        window.dataLayer = window.dataLayer ?? [];
        AlmaAccountAnalytics.instance.logger.info("Waiting for CMP to be available");
        continueOnceCMPAvailable(AlmaAccountAnalytics.instance.init);
      } else {
        console.error("AlmaAccountAnalytics: Cannot initialize in non-browser environment");
      }
    }
    return AlmaAccountAnalytics.instance;
  }
  /**
   * Initialize the analytics instance
   * This function is called when the CMP is available and
   * the analytics instance is ready to send events.
   * @private
   * @returns {Promise<void>}
   *
   */
  init = async () => {
    this.logger.info("CMP is available");
    this.logger.info(`Wait ${this.timeout}ms before emptying GA4 event queque`);
    setTimeout(() => {
      this.cmpAvailable = true;
      this.eventHandler.setCMPAvailable();
      this.eventHandler.emptyGA4EventQueue();
    }, this.timeout);
  };
  resolveAccountTypeForGA4Event = (connection) => {
    switch (connection) {
      case "Almatunnus":
        return "alma_account";
      case "Almatunnus-Business":
        return "alma_account_business";
      case "google-oauth2":
        return "google";
      case "azure-ad":
        return "azure_ad";
      default:
        return connection ?? "";
    }
  };
  sendLoginSuccess = ({
    almaIDHash,
    connection,
    source,
    lang
  } = {}) => {
    const eventSource = source ?? getEventSourceFromSessionStorage();
    const event = {
      action: "login",
      type: this.resolveAccountTypeForGA4Event(connection),
      status: "success",
      clientId: this.clientId,
      source: eventSource,
      almaIDHash,
      lang
    };
    return this.eventHandler.sendEvent(event);
  };
  sendSilentLoginSuccess = ({
    almaIDHash,
    connection,
    source,
    lang
  } = {}) => {
    const eventSource = source ?? getEventSourceFromSessionStorage();
    const event = {
      action: "login_silent",
      type: this.resolveAccountTypeForGA4Event(connection),
      status: "success",
      clientId: this.clientId,
      source: eventSource,
      almaIDHash,
      lang
    };
    return this.eventHandler.sendEvent(event);
  };
  sendSocialLoginSuccess = ({
    almaIDHash,
    connection,
    source,
    lang
  } = {}) => {
    const eventSource = source ?? getEventSourceFromSessionStorage();
    const event = {
      action: "login",
      type: this.resolveAccountTypeForGA4Event(connection),
      status: "success",
      clientId: this.clientId,
      source: eventSource,
      almaIDHash,
      lang
    };
    return this.eventHandler.sendEvent(event);
  };
  sendSignupSuccess = async ({
    almaIDHash,
    connection,
    source,
    lang
  } = {}) => {
    const eventSource = source ?? getEventSourceFromSessionStorage();
    const event = {
      action: "registration",
      type: this.resolveAccountTypeForGA4Event(connection),
      status: "success",
      clientId: this.clientId,
      source: eventSource,
      almaIDHash,
      lang
    };
    await this.eventHandler.sendEvent(event);
  };
  /**
   * Send a logout event to the analytics trackers
   * @param {EventProperties} properties - The properties for the event
   * @param {string} properties.almaIDHash - The almaIDHash for the user
   * @param {string} properties.connection - The connection for the user
   * @param {string} properties.source - The source of the event
   * @returns {Promise<void>}
   * @example
   * await window.AlmaAccountAnalytics.sendLogout({...})
   * core.logout("https://devbox.local:9000");
   */
  sendLogout = async ({
    almaIDHash,
    connection,
    source,
    lang
  } = {}) => {
    localStorage.setItem("alma-account-from-signup", "false");
    const eventSource = source ?? getEventSourceFromSessionStorage();
    const event = {
      action: "logout",
      type: this.resolveAccountTypeForGA4Event(connection),
      status: "success",
      clientId: this.clientId,
      source: eventSource,
      almaIDHash,
      lang
    };
    await this.eventHandler.sendEvent(event);
  };
  resolveEventProperties = (user, source) => {
    const connection = user["https://almamedia.net/connection"] ?? "";
    const almaIDHash = user["https://almamedia.net/almaIDHash"] ?? "";
    const lang = user["https://almamedia.net/lang"] ?? "fi";
    const fromSignup = user["https://almamedia.net/fromSignUp"] ?? false;
    const silentLogin = user["https://almamedia.net/silent_login"] ?? void 0;
    const mode = user["https://almamedia.net/mode"] ?? void 0;
    const theme = user["https://almamedia.net/theme"] ?? void 0;
    return {
      almaIDHash,
      connection,
      source,
      lang,
      fromSignup,
      silentLogin,
      mode,
      theme
    };
  };
  /**
   * Send a user event to the analytics trackers
    /**
      * Send a user event to the analytics trackers
      * @param {Object} params - The parameters for the event
      * @param {UserObject} params.user - The user object
      * @param {string} [params.source] - The source of the event
      *
      * @returns {void}
      * @example
      * await core.isAuthenticated().then(async () => {
      *   const user = await core.getUserInfo()
      *   window.AlmaAccountAnalytics.sendUserEvent({
      *    user,
      *    source: "my-source"
      *   })
      * })
      */
  sendUserEvent = ({ user, source }) => {
    if (user && typeof user === "object" && "https://almamedia.net/almaIDHash" in user) {
      const eventProperties = this.resolveEventProperties(user, source);
      if (!eventProperties.fromSignup) {
        localStorage.setItem("alma-account-from-signup", "false");
      }
      if (eventProperties.fromSignup && !JSON.parse(localStorage.getItem("alma-account-from-signup") ?? "false")) {
        localStorage.setItem("alma-account-from-signup", "true");
        this.sendSignupSuccess(eventProperties);
      }
      if (eventProperties.connection !== "Almatunnus" && eventProperties.connection !== "Almatunnus-Business") {
        this.sendSocialLoginSuccess(eventProperties);
      } else if (eventProperties.silentLogin) {
        this.sendSilentLoginSuccess(eventProperties);
      } else {
        this.sendLoginSuccess(eventProperties);
      }
    }
  };
}

export { AlmaAccountAnalytics };
//# sourceMappingURL=index.min.mjs.map
